import { useState, useRef } from 'react'
import { PaywallAuthErrorCodes, SignInType } from '../../../../../global/paywall/paywallInterfaces';


export interface PremiumPaywallMobileSigninPasswordProps {
  password: string
  emailOrPhone: string
  setPassword: (password: string) => void
  onContinue: () => void
  onBack?: () => void
  sendMail: () => void
  setEmailOrPhone: (emailOrPhone: string) => void
  authError: string
  signInType: SignInType
}
export const OTP_LENGTH = 6;

export const PremiumPaywallMobileSigninPassword = (props: PremiumPaywallMobileSigninPasswordProps) => {

  const { emailOrPhone, setPassword, onContinue, sendMail, authError, signInType } = props
  const [otp, setOtp] = useState<string[]>(Array(OTP_LENGTH).fill(''));
  const inputRefs = useRef<Array<HTMLInputElement | null>>(Array(OTP_LENGTH).fill(null));

  const isOtpComplete = otp.every(value => value.trim() !== '');
  const errorMesssagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
    [PaywallAuthErrorCodes.AUTHENTICATION_FAILED]: 'האימות נכשל או שפג תוקפו של קוד האימות, יש לנסות שוב',
    [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
    [PaywallAuthErrorCodes.INVALID_PASSWORD]: 'האימות נכשל או שפג תוקפו של קוד האימות, יש לנסות שוב',
  }

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    inputRefs.current[index].style.borderColor = '#999999';
    if (value && index < OTP_LENGTH - 1) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
    if (newOtp.every((v) => v)) {
      setPassword(newOtp.join(''))
    }
  };

  const handleKeyDown = (event: KeyboardEvent, index: number) => {


    if (event.key === 'Backspace' || event.key === 'Delete' && index > 0) {
      event.preventDefault();
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
    if (event.key === 'ArrowLeft' && index > 0) {
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
    if (event.key === 'ArrowRight' && index < OTP_LENGTH - 1) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if (isOtpComplete) {
        handleOnContinue();
      }
    }
  };

  const handlePaste = (event: ClipboardEvent) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text');
    if (pastedData.length !== otp.length || !/^\d+$/.test(pastedData)) {
      return;
    }
    const newOtp = pastedData.split('');
    setOtp(newOtp);
    if (inputRefs.current[otp.length - 1]) {
      inputRefs.current[otp.length - 1].focus();
    }
    setPassword(newOtp.join(''));
  };

  const handleSendMailAgain = () => {
    resetOtpInputs();
    sendMail();
  }

  const resetOtpInputs = () => {
    setOtp(Array(OTP_LENGTH).fill(''));
    inputRefs.current.forEach((input) => {
      if (input) {
        input.style.borderColor = '#999999';
      }
    });
  }

  const handleOnContinue = () => {
    const emptyOtpFields = inputRefs.current.filter((_, index) => otp[index] === '');
    if (emptyOtpFields.length > 0) {
      emptyOtpFields.forEach((input) => {
        if (input) {
          input.style.borderColor = '#DE1A1A';
        }
      });
    } else {
      onContinue();
    }
  }

  const renderDescription = () => {
    if (signInType === SignInType.otpEmail) {
      return <><span>שלחנו קוד אימות לכתובת הדוא"ל שהזנת: </span><span className="bold">{emailOrPhone}</span></>
    }
    if(signInType === SignInType.otpPhone){
      return <><span>שלחנו קוד אימות למספר הטלפון הנייד שהזנת: </span><span className="bold">{emailOrPhone}</span></>
    }
  }


  return (
    <div className="premium-paywall-mobile-signin-password">
      <div className="title">אימות מנוי</div>
      <div className="subtitle">
        {renderDescription()}
        <div>יש להזין כאן את הקוד שקיבלת</div>
      </div>
      <div className="otp">
        {otp.map((_, index) => {
          return (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxLength={1}
              autocomplete="one-time-code"
              value={otp[index]}
              onChange={(e: any) => handleChange(e.target.value, index)}
              onKeyDown={(e: any) => handleKeyDown(e, index)}
              onPaste={(e: any) => handlePaste(e)}
              onBeforeInput={(e: any) => handleChange(e.data, index)}
            />
          );
        })}
      </div>
      {authError && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMesssagesServer[authError] }}></p>}
      <span className="avalibale-label">הקוד תקף ל-15 דקות</span>
      <div className="buttons-container">
        <button className="button-base continue" disabled={!isOtpComplete} onClick={handleOnContinue}>המשך</button>
      </div>

      <div className="resend-code-text">
        הקוד לא הגיע?<button onClick={handleSendMailAgain}>לשליחה מחדש</button>
      </div>
    </div>
  )
}
